import React from 'react';
import { NavLink } from 'react-router-dom';
import '../style.scss';

export interface MenuTypeData {
    key: string;
    value: string;
    style: string;
    exact: boolean;
}

interface StateProps {
    menuType: MenuTypeData;
}

type Props = StateProps;

const HeaderType: React.FC<Props> = (props: Props) => {
    const { menuType } = props;

    return (
        <>
            <ul className="nav nav-pills nav-fill">
                <li className="nav-item">
                    <NavLink activeClassName="nav-link active" className={menuType.style} exact={menuType.exact} to={menuType.value}>
                        {menuType.key}
                    </NavLink>
                </li>
            </ul>
        </>
    );
};
export default HeaderType;
